export default __webpack_public_path__ + "../staticImages/icon-suggest-assistant-black.svg";